'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import SkeletonDurationPicker from 'MeetingsLib/components/schedule/duration/SkeletonDurationPicker';
import DurationPicker from 'MeetingsLib/components/schedule/duration/DurationPicker';
import SkeletonTimePicker from 'MeetingsLib/components/schedule/time/SkeletonTimePicker';
import TimePicker from 'MeetingsLib/components/schedule/time/TimePicker';
import StepButtonsFooter from 'MeetingsLib/components/page/StepButtonsFooter';
import UserProfile from 'MeetingsBase/models/UserProfile';
import Branding from 'MeetingsBase/models/Branding';
var TimeOptionsSection = createReactClass({
  displayName: "TimeOptionsSection",
  propTypes: {
    branding: PropTypes.instanceOf(Branding).isRequired,
    compact: PropTypes.bool.isRequired,
    isFetchingPublicAvailability: PropTypes.bool.isRequired,
    goToPreviousStep: PropTypes.func,
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    resetEventDateTime: PropTypes.func.isRequired,
    TimePickerMarker: PropTypes.func.isRequired
  },
  handleGoToPreviousStep: function handleGoToPreviousStep() {
    var _this$props = this.props,
        resetEventDateTime = _this$props.resetEventDateTime,
        goToPreviousStep = _this$props.goToPreviousStep;
    resetEventDateTime();
    goToPreviousStep();
  },
  renderTimePicker: function renderTimePicker() {
    var _this$props2 = this.props,
        branding = _this$props2.branding,
        compact = _this$props2.compact,
        isFetchingPublicAvailability = _this$props2.isFetchingPublicAvailability,
        profile = _this$props2.profile,
        TimePickerMarker = _this$props2.TimePickerMarker;

    if (isFetchingPublicAvailability) {
      return /*#__PURE__*/_jsx(SkeletonTimePicker, {});
    }

    return /*#__PURE__*/_jsx(TimePicker, {
      branding: branding,
      compact: compact,
      profile: profile,
      TimePickerMarker: TimePickerMarker
    });
  },
  renderDurationPicker: function renderDurationPicker() {
    if (this.props.isFetchingPublicAvailability) {
      return /*#__PURE__*/_jsx(SkeletonDurationPicker, {});
    }

    return /*#__PURE__*/_jsx(DurationPicker, {});
  },
  renderStepButtonsFooter: function renderStepButtonsFooter() {
    var _this$props3 = this.props,
        branding = _this$props3.branding,
        compact = _this$props3.compact;

    if (!compact) {
      return null;
    }

    return /*#__PURE__*/_jsx(StepButtonsFooter, {
      branding: branding,
      compact: compact,
      goToPreviousStep: compact ? this.handleGoToPreviousStep : null
    });
  },
  render: function render() {
    var compact = this.props.compact;
    return /*#__PURE__*/_jsxs(UICardWrapper, {
      className: "m-bottom-0 flex-column min-height-0 height-100",
      children: [/*#__PURE__*/_jsxs(UICardSection, {
        flush: true,
        className: "p-all-0 m-bottom-0 flex-column min-height-0 height-100",
        scrollable: compact,
        children: [this.renderDurationPicker(), this.renderTimePicker()]
      }), this.renderStepButtonsFooter()]
    });
  }
});
export default connect(null, FormActions)(TimeOptionsSection);